// ══════════════════════════════════════════════════════════════════════════════════════════════
//  LOS AVISOS DEL SISTEMA DE UN BUSCA QUE YA NO SUENA, FUERA (B-914, 28-sep-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño: «si lo acepto en uno, se quita en todos para que no siga molestando». Dentro de la app lo para el aviso en
//  directo y la lista del servidor (components/busca/BuscaEntrante). Esto quita, además, lo que quedó FUERA de la app:
//   · en la app del móvil, las notificaciones entregadas de un busca que ya no suena (Capacitor PushNotifications:
//     se reconocen por su etiqueta «busca-N» en Android o por su `busca_id` en el iPhone);
//   · en el navegador, las del service worker con esa etiqueta.
//  `siguen` son los ids que el servidor dice que siguen sonando: lo demás sobra. Nunca lanza: si no hay de dónde quitar
//  (un navegador sin service worker, una app antigua), no pasa nada.
const deBusca = (n) => {
  if (!n) return null
  const m = /^busca-(\d+)$/.exec(String(n.tag || ''))
  if (m) return m[1]
  const d = n.data || {}
  if ((d.tipo === 'busca' || d.tipo === 'busca_parar') && d.busca_id != null) return String(d.busca_id)
  return null
}

export async function cerrarAvisosDelBusca(siguen, entorno) {
  const w = entorno || (typeof window !== 'undefined' ? window : null)
  if (!w) return
  const vivos = new Set((Array.isArray(siguen) ? siguen : []).map((x) => String(x)))
  // 1) La app del móvil.
  try {
    const PN = w.Capacitor && w.Capacitor.Plugins && w.Capacitor.Plugins.PushNotifications
    if (PN && typeof PN.getDeliveredNotifications === 'function' && typeof PN.removeDeliveredNotifications === 'function') {
      const r = await PN.getDeliveredNotifications()
      const sobran = ((r && r.notifications) || []).filter((n) => { const id = deBusca(n); return id != null && !vivos.has(id) })
      if (sobran.length) await PN.removeDeliveredNotifications({ notifications: sobran })
    }
  } catch { }
  // 2) El navegador.
  try {
    const sw = w.navigator && w.navigator.serviceWorker
    const reg = sw && typeof sw.getRegistration === 'function' ? await sw.getRegistration() : null
    if (reg && typeof reg.getNotifications === 'function') {
      for (const n of await reg.getNotifications()) {
        const id = deBusca(n)
        if (id != null && !vivos.has(id)) n.close()
      }
    }
  } catch { }
}
